<template>
  <div class="Index">
    <div class="banner">
      <van-swipe class="my-swipe"
                 :autoplay="3000"
                 indicator-color="white">
        <van-swipe-item>
          <div class="bgbox">
            <img class="bg"
                 src="@/assets/banner1.jpg"
                 alt="">
            <div class="text">
              <div class="cont">
                <div class="ct_img"
                     @click="showForm = true">
                  <img src="@/assets/b1.png"
                       alt="">
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="bgbox">
            <img class="bg"
                 src="@/assets/banner2.jpg"
                 alt="">
            <div class="text">
              <div class="cont">
                <div class="ct_img"
                     @click="showForm = true">
                  <img src="@/assets/b1.png"
                       alt="">
                </div>
              </div>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="searchBar">
      <div class="input_item">
        <span @click="dq_show = true">请选择
          <van-icon name="arrow-down" />
        </span><input type="text"
               v-model="searchVal"
               @keyup.enter="onSearch"
               placeholder="搜索大学"><span>
          <van-icon name="search"
                    @click="onSearch" />
        </span>
      </div>
    </div>
    <div class="fg shortcut_menu">
      <van-grid :column-num="3">
        <van-grid-item url="/mobile/school-list/0">
          <van-image width="50"
                     :src="require('@/assets/s01.png')" />
          <p class="navtit">选择学校</p>
        </van-grid-item>
        <van-grid-item url="/mobile/jiangxuejin/12">
          <van-image width="50"
                     :src="require('@/assets/s02.png')" />
          <p class="navtit">奖学金</p>
        </van-grid-item>
        <van-grid-item url="/mobile/shenqing/0">
          <van-image width="50"
                     :src="require('@/assets/s03.png')" />
          <p class="navtit">助学服务</p>
        </van-grid-item>
        <van-grid-item url="/mobile/yuyan/0">
          <van-image width="50"
                     :src="require('@/assets/s04.png')" />
          <p class="navtit">教育中心</p>
        </van-grid-item>
        <van-grid-item url="/mobile/shenghuo/0">
          <van-image width="50"
                     :src="require('@/assets/s05.png')" />
          <p class="navtit">生活旅行</p>
        </van-grid-item>
        <van-grid-item @click="showForm = true">
          <van-image width="50"
                     :src="require('@/assets/s06.png')" />
          <p class="navtit">申请咨询</p>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="fg gonggao">
      <div class="container">
        <a href="/mobile/about/0"
           class="headTit">
          <h3>助学公告</h3>
          <div class="btns">
            <div class="imgbox">
              <img src="@/assets/jtr.png"
                   alt="">
            </div>
          </div>
        </a>
        <div class="cont">
          <div class="imgbox">
            <img src="@/assets/gonggao.jpg"
                 alt="">
          </div>
          <div class="text">
            <p v-if="gonggao_flag==0">
              助学于2006年开始运营，为了响应不断增加的国际学生的留学需求，助学逐渐发展成为专门为国际学生留学提供便捷之路的网络...
              <span @click="gonggao_flag=1">
                【了解详情】
              </span>
            </p>
            <p v-else>
              助学于2006年开始运营，为了响应不断增加的国际学生的留学需求，助学逐渐发展成为专门为国际学生留学提供便捷之路的网络，在助学网上有着世界各地国际学生所需求和关系的主要在线资源。我们的目标是帮助这些学生能够实现他们的求学梦想，看到更加广阔的世界，增进他们对教育的理解，增加双边交流。我们希望以一切可以想象的方式帮助学生，使他们在国际教育事业中取得成功。
              <span @click="gonggao_flag=0">
                【了解详情】
              </span>
            </p>

          </div>
        </div>
      </div>
    </div>
    <div class="fg yuanxiao">
      <div class="container">
        <a href="/mobile/school-list/0"
           class="headTit">
          <h3>重点推广院校</h3>
          <div class="btns">
            <div class="imgbox">
              <img src="@/assets/jtr.png"
                   alt="">
            </div>
          </div>
        </a>
        <div class="cont">
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(item,index) in recList"
                            :key="index">
              <div class="cont-lis">
                <van-row gutter="10">
                  <van-col span="12"
                           v-for="(item2,index) in item"
                           :key="index">
                    <a :href="'/mobile/school-detail/'+item2.id"
                       class="lis">
                      <div class="imgbox">
                        <span>
                          <i class="icobox"><img src="@/assets/ico1.png"
                                 alt=""> </i> {{(item2.rank == 9999 ? item2.moerank:item2.rank) == 9999 ? '-' :(item2.rank == 9999 ? 'MOE:'+item2.moerank:'QS:'+item2.rank)}}
                        </span>
                        <img :src="item2.thumb"
                             alt="">
                      </div>
                      <h3> {{item2.name}} </h3>
                    </a>
                  </van-col>
                </van-row>
              </div>
            </van-swipe-item>
          </van-swipe>

        </div>
      </div>
    </div>
    <div class="fg youshi">
      <div class="container">
        <a href="javascript"
           class="headTit">
          <h3>优势项目</h3>

        </a>
      </div>
      <div class="cont">
        <van-swipe :autoplay="3000"
                   :width="windowsWidth/2">
          <van-swipe-item v-for="(item,index) in ysList"
                          :key="index">
            <a href="javascript:;"
               @click="onPage(item.video)"
               class="lis">
              <div class="imgbox">
                <img :src="item.thumb"
                     alt="">
                <div class="text">
                  <h3> {{item.title}} </h3>
                  <p> {{item.description}} </p>
                </div>
              </div>
            </a>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <div class="fg shipin">
      <div class="container">
        <a href="javascript:;"
           class="headTit">
          <h3>助学在线</h3>
        </a>
      </div>
      <div class="cont">
        <van-swipe :autoplay="3000"
                   :width="(windowsWidth == '' ? 375:windowsWidth)/2">
          <van-swipe-item v-for="(item,index) in videoList"
                          :key="index">
            <a class="lis"
               @click="showVideo(item.video)">
              <div class="imgbox">
                <img :src="item.thumb"
                     alt="">

              </div>
              <div class="text">
                <h3> {{item.title}} </h3>
              </div>
            </a>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>

    <div class="shenqingBtn">
      <div class="imgbox"
           @click="showForm = true">
        <img src="@/assets/shenqing.jpg"
             alt="">
      </div>
    </div>

    <van-popup v-model="showPop"
               @close="videoUrl = ''">
      <div class="videoBox"
           v-if="videoUrl != ''">
        <video id="myVideo"
               Controls
               class="video-js">
          <source :src="videoUrl"
                  type="video/mp4">
        </video>
      </div>
    </van-popup>

    <van-popup v-model="showForm"
               position="bottom"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="formCont">
        <div class="head">
          完善信息填报申请
        </div>
        <van-form @submit="onSubmit">
          <van-field v-model="form1.cert_name"
                     name="姓名"
                     label="姓名"
                     placeholder="姓名"
                     :rules="[{ required: true, message: '请填写姓名' }]" />
          <van-field v-model="form1.phone"
                     name="电话"
                     label="电话"
                     placeholder="电话"
                     :rules="[{ required: true, message: '请填写电话' }]" />
          <van-field v-model="form1.email"
                     name="邮箱"
                     label="邮箱"
                     placeholder="邮箱"
                     :rules="[{ required: true, message: '请填写邮箱' }]" />
          <van-field v-model="form1.country"
                     name="所在城市"
                     label="所在城市"
                     placeholder="所在城市"
                     :rules="[{ required: true, message: '请填写您的城市' }]" />
          <van-field name="checkboxGroup"
                     label="其他">
            <template #input>
              <van-checkbox-group v-model="form1.subject"
                                  direction="horizontal">
                <van-checkbox name="签证服务"
                              shape="square">签证服务</van-checkbox>
                <van-checkbox name="机场接机"
                              shape="square">机场接机</van-checkbox>
                <van-checkbox name="住宿预定"
                              shape="square">住宿预定</van-checkbox>
                <van-checkbox name="奖学金"
                              shape="square">奖学金</van-checkbox>
                <van-checkbox name="论文核对"
                              shape="square">论文核对</van-checkbox>
                <van-checkbox name="手机卡申请"
                              shape="square">手机卡申请</van-checkbox>
                <van-checkbox name="保险申请"
                              shape="square">保险申请</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field v-model="form1.content"
                     name="备注"
                     label="备注"
                     placeholder="备注"
                     type="textarea"
                     maxlength="150" />
          <div style="margin: 16px;">
            <van-button round
                        block
                        type="info"
                        native-type="submit">提交</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <van-popup v-model="showSearch"
               position="bottom"
               duration='0'
               :style="{ height: '100%' }">
      <div class="searchCont">
        <Search></Search>
      </div>
    </van-popup>

    <van-popup v-model="dq_show"
               round
               position="bottom">
      <van-cascader v-model="dq_cascaderValue"
                    title="请选择所在地区"
                    :options="dq_options"
                    active-color="#263e65"
                    @close="dq_show = false"
                    @change="onChange_dq"
                    @finish="onFinish_dq" />
    </van-popup>
  </div>
</template>
<script>
import axiosApi from "../api/api.js";
import Search from '@/components/Search.vue'
import { Toast } from 'vant';

export default {
  components: {
    Search
  },
  data () {
    return {
      form1: {
        cert_name: '',
        phone: '',
        email: '',
        country: '',
        subject: [],
        content: ''
      },
      windowsWidth: '',
      gonggao_flag: 0,
      recList: [],
      ysList: [],
      videoList: [],
      videoUrl: '',
      showPop: false,
      showForm: false,
      showSearch: false,
      dq_show: false,
      dq_cascaderValue: '',
      dq_options: [],
      searchVal: ''
    }
  },
  methods: {
    showVideo (url) {
      this.videoUrl = url
      this.showPop = true
    },

    onSHowMenuList2 () {

    },
    onSubmit () {
      axiosApi('message', {
        form_type: 12,
        ...this.form1
      }, 'post').then(res => {
        if (res.data.status) {
          Toast.success('success')
          this.form1 = {
            cert_name: '',
            phone: '',
            email: '',
            country: '',
            subject: [],
            content: ''
          }
          this.$emit('hideForm');
          this.$refs.formName.resetValidation();
        } else {
          Toast.fail('error')
        }
      })
    },
    onChange_dq ({ value }) {
      let oldarr = this.dq_options
      let that = this
      oldarr.forEach(function (item, index) {
        if (item.value == value) {
          that.cyindex = index
        }
      });

      axiosApi(
        'university/province/' + value, {}, 'get'
      ).then((res) => {
        const arr = res.data
        let narr = []
        arr.forEach(function (item) {
          narr = [...narr, { text: item.name, value: item.code.slice(0, 4) }]
        });
        this.dq_options[this.cyindex].children = narr
      })

    },
    onFinish_dq ({ selectedOptions }) {
      this.dq_show = false;
      this.$router.push({ path: '/school-list/10', query: { city: selectedOptions[1].value } });
    },
    onSearch () {
      if (this.searchVal != '') {
        this.$router.push({ path: '/school-list/11', query: { searchVal: this.searchVal } });
      }
    },
    onPage (links) {
      if (!links) return true
      if (links.length > 0) {
        window.location.href = '/mobile/school-detail/' + links.replace(/[^\d]/g, "")
      }
    }
  },
  mounted () {
    this.windowsWidth = document.body.clientWidth - (50 / (750 / document.body.clientWidth))
    axiosApi(
      'university/recommend', {}, 'get'
    ).then((res) => {
      let baseArray = res.data.data
      let len = baseArray.length;
      let n = 4; //假设每行显示4个
      let lineNum = len % 4 === 0 ? len / 4 : Math.floor((len / 4) + 1);
      let narr = [];
      for (let i = 0; i < lineNum; i++) {
        // slice() 方法返回一个从开始到结束（不包括结束）选择的数组的一部分浅拷贝到一个新数组对象。且原始数组不会被修改。
        let temp = baseArray.slice(i * n, i * n + n);
        narr.push(temp);
      }
      this.recList = narr

    })
    axiosApi(
      'news/22', {}, 'get'
    ).then((res) => {
      this.ysList = res.data.data
    })
    axiosApi(
      'news/21', {}, 'get'
    ).then((res) => {
      this.videoList = res.data.data
    })
    axiosApi(
      'university/province', {}, 'get'
    ).then((res) => {
      const arr = res.data
      let narr = []
      arr.forEach(function (item) {
        narr = [...narr, { text: item.name, value: item.id, children: [] }]
      });
      this.dq_options = narr
    })
  }
}
</script>

<style lang="scss" scoped>
.Index {
  padding-bottom: 25px;
  background-color: #f7f8fa;
  .fg {
    background-color: #fff;
    width: 700px;
    margin: auto;
    overflow: hidden;
    margin-bottom: 20px;
    border-radius: 15px;
  }
}
.banner {
  .bgbox {
    position: relative;
    img.bg {
      display: block;
      width: 100%;
    }
    .text {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 999;
      display: flex;
      // padding: 0 60px 0;
      flex-direction: column;
      justify-content: center;
      .ct_img {
        width: 750px;
        margin-top: -40px;
        img {
          display: block;
          width: 100%;
        }
      }
    }
  }
}
.searchBar {
  // background-color: #263e65;
  padding: 20px 0;
  margin-bottom: 50px;
  margin-top: -120px;
  position: relative;
  z-index: 99;
  .input_item {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    overflow: hidden;
    width: 700px;
    margin: auto;
    background-color: #fff;
    input {
      height: 50px;
      line-height: 50px;
      width: 550px;
      border-radius: 0;
    }
    span {
      width: max-content;
      line-height: 50px;
      height: 50px;
      color: #263e65;
      padding: 0 10px;
      text-align: center;
      background-color: #fff;
      &:nth-child(3n) {
        background-color: #526fb6;
        color: #fff;
        padding: 0 20px;
      }
    }
  }
}
.shortcut_menu {
  .navtit {
    margin-top: 15px;
    font-size: 28px;
  }
}
.gonggao {
  padding: 40px 0;
  .text {
    padding-top: 20px;
    p {
      text-indent: 2em;
      font-size: 28px;
      line-height: 42px;
    }
    span {
      position: relative;
      // margin-top: -60px;
      z-index: 1;
      // background-image: linear-gradient(
      //   transparent,
      //   rgba(255, 255, 255, 1),
      //   rgba(255, 255, 255, 1)
      // );
      color: #f29810;
      text-align: center;
      // padding-top: 40px;
      border-radius: 10px;
    }
  }
}

.yuanxiao {
  padding: 40px 0;
  .cont {
    .cont-lis {
      padding-bottom: 40px;
    }
    .lis {
      display: block;
      margin-bottom: 20px;
      .imgbox {
        border-radius: 15px;
        position: relative;
        span {
          position: absolute;
          top: 0;
          left: 0;
          color: #fff;
          background-color: #f29810;
          padding: 10px;
          display: flex;
          align-items: center;
          line-height: 1;
          .icobox {
            width: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
            img {
              max-width: 100%;
            }
          }
        }
      }
      h3 {
        margin-top: 10px;
        text-align: center;
      }
    }
  }
}

.youshi {
  padding: 40px 0;
  .lis {
    display: block;
    padding: 10px;
    padding-bottom: 60px;
    .imgbox {
      position: relative;
      .text {
        position: absolute;
        bottom: 0;
        padding: 20px;
        height: 200px;
        width: 100%;
        background-color: rgba($color: #ffffff, $alpha: 0.6);
        h3 {
          color: #f29810;
          height: 80px;
        }
      }
    }
  }
}
.shipin {
  padding: 40px 0;
  .lis {
    display: block;
    padding: 10px;
    padding-bottom: 60px;

    .imgbox {
      border-radius: 10px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 80px;
        height: 80px;
        background: url(~@/assets/bf.png) center center no-repeat;
        background-size: 100%;
      }
    }
    .text {
      margin-top: 10px;
      text-align: center;
    }
  }
}
.videoBox {
  width: 700px;
  video {
    width: 100%;
    height: auto;
  }
}
.shenqingBtn {
  width: 700px;
  margin: auto;
  .imgbox {
    border-radius: 10px;
    width: 100%;
    img {
      width: 100%;
    }
  }
}

.van-checkbox {
  margin-bottom: 20px;
}
.formCont {
  padding-top: 20px;
  padding-bottom: 60px;
  .head {
    text-align: center;
    font-size: 36px;
    margin-bottom: 20px;
  }
}
.van-swipe__indicator {
  border-radius: 8px;
  width: 30px;
  height: 8px;
}
.van-swipe__indicator--active {
  background-color: #f29810;
}
</style>

<style lang="scss">
</style>